// @ts-check

import { motion } from 'framer-motion';
import { clsx } from "@minohealth/common/utils/classnames"
import './text-shimmer.css';

/**
 * TextShimmer component props
 * @typedef {Object} TextShimmerProps
 * @property {string} children - The text content to shimmer
 * @property {React.ElementType} [as] - The HTML element to render as
 * @property {string} [className] - Additional CSS classes
 * @property {number} [duration] - Animation duration in seconds
 * @property {number} [spread] - Shimmer spread multiplier
 * @property {[string, string]} [gradientColors] - Array of two colors for the gradient
 */

/**
 * TextShimmer component that creates a shimmering text effect
 * @param {TextShimmerProps} props - Component props
 */
export function TextShimmer({
  children,
  as: Component = 'p',
  className,
  duration = 1,
  spread = 2,
  gradientColors = ['#71717a', '#ffffff'],
}) {
  const MotionComponent = motion.create(Component)

  const dynamicSpread = children.length * spread;

  return (
    <MotionComponent
      className={clsx('text-shimmer', className)}
      initial={{ backgroundPosition: '100% center' }}
      animate={{ backgroundPosition: '0% center' }}
      transition={{
        repeat: Infinity,
        duration,
        ease: 'linear',
      }}
      style={{
        '--spread': `${dynamicSpread}px`,
        '--base-color': gradientColors[0],
        '--base-gradient-color': gradientColors[1],
      }}
    >
      {children}
    </MotionComponent>
  );
}